import { Tabs } from '@chakra-ui/react';
import InfoMarker from 'components/elements/InfoMarker';
import { TabsList } from 'components/elements/TabsList';
import { FlexRow } from 'components/layout/FlexRow';
import { useProjectInsightsViewType, useSelectedPolygonBoundsOnMap } from 'state/map';

const HEADINGS = [
  'List',
  {
    label: 'Map',
    icon: (
      <InfoMarker label="Some projects may not appear on the map due to invalid addresses." />
    ),
  },
];

const ToggleButton = () => {
  const [viewType, setViewType] = useProjectInsightsViewType();
  const [selectedPolygonBoundsOnMap] = useSelectedPolygonBoundsOnMap();

  // When a parcel is selected on the map, hide the Map/List toggle.
  if (selectedPolygonBoundsOnMap) {
    return null;
  }

  return (
    <FlexRow>
      <Tabs
        variant="enclosed"
        index={viewType === 'map' ? 1 : 0}
        onChange={(index) => {
          setViewType(index === 1 ? 'map' : 'list');
        }}
      >
        <FlexRow>
          <TabsList tabLabels={HEADINGS} />
        </FlexRow>
      </Tabs>
    </FlexRow>
  );
};

export default ToggleButton;
